module.exports = __webpack_public_path__ + "img/Your Sentiments.e900cb78.svg";